import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ngf } from 'angular-file';
import { HttpRequest, HttpHeaders, HttpEventType } from '@angular/common/http';
import { HttpClient } from '@angular/common/http';
import { HttpResponse } from '@angular/common/http';
import { interval } from 'rxjs/observable/interval';
import { throttleTime } from 'rxjs/operators/throttleTime';
import { Configuration } from '../app.constants';


@Component({
    selector: 'home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss'],
})
export class HomeComponent implements OnInit {
    public canConvert: boolean = true;
    public isBusy: boolean;
    public files: File[];
    public isValidate: boolean;
    public allowMoreFiles: boolean = true;
    private allowedFileTypes: string[];
    private wordFileTypes = ["doc", "docx"];
    private excelFileTypes = ["xls", "xlsx", "xlt", "xlsm"];
    private xbrlFileTypes = ["xbrl"];
    private jsonFileTypes = ["json"];
    private csvFileTypes = ["csv"];
    public acceptFilter: string;

    constructor(private _router: Router, private _httpClient: HttpClient, private _config:Configuration) {

    }

    ngOnInit(): void {
        this.acceptFilter = this.getAllFileTypes();
    }

    convert() {

        console.log(this._config.Server);
        

        this.isBusy = true;
        let formData = new FormData()
        this.files.forEach(file => {
            formData.append(file.name, file, file.name);
        });

        const config = new HttpRequest('POST', `${this._config.Server}/api/conversion/convert`, formData, {
            reportProgress: true,
            responseType: 'text'
        });

        return this._httpClient.request(config)
            .subscribe(event => {
                if (event.type === HttpEventType.DownloadProgress) {
                    console.log("Download progress event", event);
                }

                if (event.type === HttpEventType.UploadProgress) {
                    console.log("Upload progress event", event);
                }

                if (event.type === HttpEventType.Response) {
                    console.log(event.body);
                    var conversionId = event.body;
                    var internalSubscription = interval(1000).subscribe(x => {
                        this._httpClient.get<boolean>(`${this._config.Server}/api/conversion/${conversionId}/status`).subscribe(response => {
                            if (response == true) {
                                internalSubscription.unsubscribe();
                                this._router.navigateByUrl(`/report/${conversionId}`);
                            }
                        },
                            error => {
                                console.log(error);
                                internalSubscription.unsubscribe();
                            })
                    });
                }
            },
            error => {
                console.log(error);
                this.isBusy = false;
            });

        //this._conversionService.convert(formData);
    }

    validate() {
        this.isBusy = true;

        let formData = new FormData()
        this.files.forEach(file => {
            formData.append(file.name, file, file.name);
        });

        const config = new HttpRequest('POST', `${this._config.Server}/api/validate`, formData, {
            reportProgress: true
        });

        return this._httpClient.request(config)
            .subscribe(event => {
                if (event.type === HttpEventType.DownloadProgress) {
                    console.log("Download progress event", event);
                }

                if (event.type === HttpEventType.UploadProgress) {
                    console.log("Upload progress event", event);
                }

                if (event.type === HttpEventType.Response) {
                    console.log(event.body);
                    var body = <any>event.body;
                    var validationId = body.validationId;
                    var internalSubscription = interval(1000).subscribe(x => {
                        this._httpClient.get<boolean>(`${this._config.Server}/api/validate/${validationId}/status`).subscribe(response => {
                            if (response == true) {
                                internalSubscription.unsubscribe();
                                this._router.navigateByUrl(`/report/${validationId}?validate=true`);
                            }
                        })
                    });
                }
            },
                error => {
                    console.log(error);
                    this.isBusy = false;
                });

    }

    onFilesChange($evt: any) {
        var allowedFileTypes = this.wordFileTypes.concat(this.excelFileTypes).concat(this.xbrlFileTypes).concat(this.csvFileTypes).concat(this.jsonFileTypes);
        this.allowMoreFiles = true;

        if (this.files.length == 0) {
            console.log("no files");
            this.acceptFilter = this.getAllFileTypes();
            return;
        }

        for (var i = 0; i < this.files.length; i++) {
            if (!this.allowMoreFiles) {
                console.log("no more files allowed");
                this.files.length = i;
            }
            else {
                var extension = this.getExtension(this.files[i].name);
                if (extension == null || allowedFileTypes.indexOf(extension) == -1) {
                    console.log("invalid extension");
                    this.files.length = i;               
                } else {
                    if (this.excelFileTypes.indexOf(extension) > -1) {
                        this.acceptFilter = this.buildAcceptString(this.wordFileTypes);
                        allowedFileTypes = this.wordFileTypes;
                        this.allowMoreFiles = i == 0;
                        this.isValidate = false;
                    } else if (this.wordFileTypes.indexOf(extension) > -1) {
                        this.acceptFilter = this.buildAcceptString(this.excelFileTypes);
                        this.allowMoreFiles = i == 0;
                        allowedFileTypes = this.excelFileTypes;
                        this.isValidate = false;
                    } else if (this.xbrlFileTypes.indexOf(extension) > -1) {
                        allowedFileTypes = [];
                        this.allowMoreFiles = false;
                        this.isValidate = true;
                    } else {
                        allowedFileTypes = [];
                        this.allowMoreFiles = false;
                        this.isValidate = false;
                    }
                }
            }
        }
    }

    fileOver($evt: any) {
        
    }

    reset() {
        this.files.length = 0;
    }

    private getExtension(fileName: string) {
        if (fileName == null) {
            return null;
        }

        var parts = fileName.split(".");
        if (parts.length == 1) {
            return null;
        }

        return parts[parts.length - 1].toLowerCase();
    }

    private buildAcceptString(...fileTypes: string[][]) {
        var result: string = "";

        for (var i = 0; i < fileTypes.length; i++) {
            var ts = fileTypes[i];

            if (result != "" && ts.length > 0) {
                result += ","
            }

            var first = false;
            ts.forEach((t,j) => {
                result += `.${t}`;
                if (j != ts.length - 1) {
                    result += ",";
                }
            });
        }

        console.log(result);
        return result;
    }

    private getAllFileTypes(): string {
        return this.buildAcceptString(this.excelFileTypes, this.xbrlFileTypes, this.jsonFileTypes, this.csvFileTypes, this.wordFileTypes)       
    }
}